// extracted by mini-css-extract-plugin
export default {"componentWrapper":"HeaderTopBar_componentWrapper__S70dh","languagesWrapper":"HeaderTopBar_languagesWrapper__bGuGC"};